import React, { useState } from 'react';
import './Home.css'; // Assuming you have a CSS file for styling
import GoogleAnalytics from './../../GoogleAnalytics'; // Adjust the path as necessary

export const Home = () => {
  const [expandedBooks, setExpandedBooks] = useState({});

  const toggleBook = (bookTitle) => {
    setExpandedBooks(prev => ({
      ...prev,
      [bookTitle]: !prev[bookTitle]
    }));
  };

  const books = [
    { title: 'Torah', startDate: 'June 2023', endDate: '02/06/2024', learnings: null },
    { title: 'Gospel', startDate: '02/06/2024', endDate: '03/31/24 Easter Day', learnings: null },
    { title: 'Prodigal Genius the Story of Nikola Tesla', startDate: null, endDate: '~Sept 20, 2023', learnings: null },
    { title: 'Zero to One', startDate: null, endDate: null, learnings: null },
    { title: 'The Maverick and the Machine Thomas Watson Sr', startDate: null, endDate: '11/09/2023', learnings: null },
    { 
      title: 'The greatest capitalist to ever live Thomas Watson Jr', 
      startDate: '11/09/2023', 
      endDate: '12/17/2023', 
      learnings: null 
    },
    { title: 'The secret history of the mongols Igor\'s version, the short one', startDate: '12/17/2023', endDate: '01/21/2024', learnings: null },
    { title: 'Steve Jobs', startDate: '12/17/2023', endDate: '05/04/24', learnings: null },
    { title: 'Alexander Hamilton - Ron Chernow', startDate: '01/26/2024', endDate: '06/30/24', learnings: null },
    { title: 'The Secrets of Sand Hill Road', startDate: '05/05/2024', endDate: '06/15/2024', learnings: null },
    { title: 'Innovators Dillema', startDate: '06/15/2024', endDate: '07/18/2024', learnings: null },
    { title: 'Elon Musk', startDate: '06/15/2024', endDate: '08/06/2024', learnings: null },
    { title: 'Genghis Khan and the making of the Modern World', startDate: '06/19/2024', endDate: '09/14/2024', learnings: null },
    { title: 'The Quran - M.A.S Abdel Haleem Translation', startDate: '07/27/2024', endDate: '03/26/25 on Laylat al Qadr. The same day prophet Muhammad had his first revelation from god', learnings: null },
    { title: 'In The Plex: How Google Thinks, Works, and Shapes Our Lives', startDate: '09/07/2024', endDate: '01/12/25', learnings: null },
    { title: 'Traction by Gabriel Weinberg', startDate: '09/16/2024', endDate: null, learnings: null },
    { title: '1984', startDate: '01/16/25', endDate: '05/2025', learnings: null },
    { title: 'Bhagavad Gita - Eknath Easwaran Translation', startDate: '05/21/25 4:40AM est', endDate: '10/20/2025 Diwali day', learnings: null },
  ];

  const booksReading = [
    { title: 'The History of Western Philosophy Bertrand Russell', startDate: '09/24/24', endDate: null, learnings: null },
    { title: 'The Wealth of Nations', startDate: '04/09/2025', endDate: null, learnings: null },
    { title: 'Facebook: The Inside Story - Steven Levy', startDate: 'Sept 22 2025', endDate: null, learnings: null },
    { title: 'The Dhammapada - Acharya Buddharakkhita Translation', startDate: '12/21/25', endDate: null, learnings: null },
  ];

  return (
    <div className="home-container">
      <GoogleAnalytics />
      <main className="home-main">
        <h1>Talha Khan</h1>
        <div className="social-media-links">
          <a href="https://x.com/TalhaKhan_TK_" target="_blank" rel="noopener noreferrer">Twitter</a>
          <a href="https://www.linkedin.com/in/Talha--Khan" target="_blank" rel="noopener noreferrer">LinkedIn</a>
        </div>
        <p className="contact-email">Email: Talha0128@gmail.com</p>
        <section className="books">
          <h3>Books I've Read</h3>
          <ul>
            {books.map((book, index) => {
              const hasDetails = book.startDate || book.endDate || book.learnings;
              return (
                <li key={index}>
                  <span
                    onClick={() => toggleBook(book.title)}
                    style={{ 
                      cursor: hasDetails ? 'pointer' : 'default', 
                      userSelect: 'none',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}
                  >
                    {hasDetails && (
                      <span style={{
                        display: 'inline-block',
                        transition: 'transform 0.2s ease',
                        transform: expandedBooks[book.title] ? 'rotate(90deg)' : 'rotate(0deg)',
                        fontSize: '0.8em',
                        color: '#666'
                      }}>
                        ▶
                      </span>
                    )}
                    {book.title}
                  </span>
                  {expandedBooks[book.title] && hasDetails && (
                    <div style={{ marginLeft: '24px', marginTop: '8px', color: '#555', fontSize: '0.95em' }}>
                      {book.startDate && <div style={{ marginBottom: '4px' }}>Start date: {book.startDate}</div>}
                      {book.endDate && <div style={{ marginBottom: '4px' }}>End date: {book.endDate}</div>}
                      {book.learnings && <div style={{ marginTop: '8px' }}>Learnings: {book.learnings}</div>}
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
          <h3>Books I'm Reading</h3>
          <ul>
            {booksReading.map((book, index) => {
              const hasDetails = book.startDate || book.endDate || book.learnings;
              return (
                <li key={index}>
                  <span
                    onClick={() => toggleBook(book.title)}
                    style={{ 
                      cursor: hasDetails ? 'pointer' : 'default', 
                      userSelect: 'none',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}
                  >
                    {hasDetails && (
                      <span style={{
                        display: 'inline-block',
                        transition: 'transform 0.2s ease',
                        transform: expandedBooks[book.title] ? 'rotate(90deg)' : 'rotate(0deg)',
                        fontSize: '0.8em',
                        color: '#666'
                      }}>
                        ▶
                      </span>
                    )}
                    {book.title}
                  </span>
                  {expandedBooks[book.title] && hasDetails && (
                    <div style={{ marginLeft: '24px', marginTop: '8px', color: '#555', fontSize: '0.95em' }}>
                      {book.startDate && <div style={{ marginBottom: '4px' }}>Start date: {book.startDate}</div>}
                      {book.endDate && <div style={{ marginBottom: '4px' }}>End date: {book.endDate}</div>}
                      {book.learnings && <div style={{ marginTop: '8px' }}>Learnings: {book.learnings}</div>}
                    </div>
                  )}
                </li>
              );
            })}
          </ul>

          <h3>Essays Coming Soon</h3>
          <ul>
            <li>Inheritance and the Root of All Evil and Good</li>
          </ul>

          <h3>I believe you can learn from all religions in this life</h3>

        </section>
      </main>
    </div>
  );
};
